import { TagTypes } from '../../../Api/Types/tagTypes';
import { OfferOptionType } from '../Types/offerOptionsTypes';
import { offerOptionsApi } from './offerOptionsApi';

const extendedOfferOptionsMappingsApi = offerOptionsApi.injectEndpoints({
  endpoints: (builder) => ({
    getOfferOptionTypes: builder.query<OfferOptionType[], void>({
      query: () => 'offer-options/', // <-- endpoint musi zwracać tablicę typów!
      providesTags: () => [TagTypes.OfferOptions],
    }),
  }),
  overrideExisting: false,
});
export const { useGetOfferOptionTypesQuery } = extendedOfferOptionsMappingsApi;
